import { gql } from '@apollo/client';

export const fetchInvoicesForTransactionAccount = gql`
  query fetchInvoicesForTransactionAccountV2(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: InvoicesFilterOptions
    $includeItems: Boolean
  ) {
    transactionAccount(id: $id) {
      id
      hamsInvoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        lastEvaluatedKey
        nodes {
          id
          sourceSystem
          invoiceNumber
          invoiceDueDays
          billingGroupId
          domain
          paidDate
          transactionAccountId
          creditCard {
            cardHolderName
            last4Numbers
            expirationYear
            expirationMonth
          }
          createdDate: createdTimestamp
          grandTotal: total
          dueDate
          billTo {
            fullName
            domain
            organization
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
          }
          shipTo {
            fullName
            email
            domain
            organization
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
          }
          total
          transactionAccountId
          paymentCurrency
          paymentMethod
          paymentMethodId
          createdTimestamp
          status
          pdfLink
        }
      }
      invoices(searchOptions: $searchOptions, filterOptions: $filterOptions, includeItems: $includeItems) {
        totalCount
        nodes {
          id
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          creditCardMaskedNumber
          dueDate
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          pdfLink
          transactionAccountId
          refunds {
            id
            type
            createdDate
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          status
          dunningStatus {
            errorCode
          }
          shipTo {
            id
            fullName
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
          }
          purchaseOrderNumber
          lineItems {
            orderLineId
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
